import dayjs from 'dayjs';
import Joi from 'joi';
import { getFirstRecurrenceDate } from './helpers';
import { FormValues } from './types';

const schema = Joi.object({
  frequency: Joi.string()
    .required()
    .messages({ '*': 'validation.string.empty' }),
  start_date: Joi.string()
    .required()
    .messages({ '*': 'validation.string.empty' }),
  end_date: Joi.string()
    .allow('', null)
    .custom((value, helpers) => {
      if (!value) return value;
      const data = helpers.state.ancestors[0] as Partial<FormValues>;
      const firstRecurrenceDate = getFirstRecurrenceDate(
        data.frequency,
        data.start_date,
        data.expense_date,
      );
      if (!firstRecurrenceDate) return value;
      const isAfterLimit = dayjs(firstRecurrenceDate)
        .startOf('day')
        .isAfter(dayjs(value).startOf('day'));
      if (isAfterLimit) return helpers.error('end_date.afterLimit');
      return value;
    })
    .messages({
      '*': 'expense.recurring.end_start.error',
    }),
});

export default schema;
